import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import RoutingPaths from "helper/routingPath";
import AddButton from "components/buttons/addbutton";
import ListHeadingComponent from "components/headingComponent/listHeading";
import ListButtons from "components/buttons/listButtons";
import {
  and,
  collection,
  deleteDoc,
  doc,
  endBefore,
  getDocs,
  limit,
  limitToLast,
  or,
  orderBy,
  query,
  startAfter,
  Timestamp,
  where,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import Dateformat from "helper/constant/timeFormat";
import Constant from "helper/constant/constant";
import CommonHeadings from "helper/constant/headings";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import Moment from "react-moment";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import { Button } from "primereact/button";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { ButtonGroup } from "react-bootstrap";

function DemoStudentsList() {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [demoStudentsData, setDemoStudentsData] = useState([]); // we fetch the data from the backend and shown in the form of list
  //these are pagination variables
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const [courseData, setCourseData] = useState([]);
  const [filteredDates, setFilteredDates] = useState(null);
  const [isNext, setIsNext] = useState(false);

  // MARK: use Effect
  useEffect(() => {
    fetchCoursesApi();
    fetchDemoStudentsApi();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //use layout effect function
  useLayoutEffect(() => {
    document.title = CommonHeadings.demoListLayoutHeading;
  }, []);

  // MARK:  function using in input
  const tapOnDateInput = (e) => {
    setFilteredDates(e.value);
  };;

  // MARK: Action
  // Edit data function
  const tapOnEdit = (demoStudentsData) => () => {
    navigate(RoutingPaths.editDemoStudents, { state: demoStudentsData });
  };

  // Delete data function
  const tapOnDeleteConfirm = (demoStudentsData) => () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete this student data`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        deleteDemoStudentsApi(demoStudentsData);
      }
    });
  };

  //  reset button function
  const tapOnResetButton = () => {
    setFilteredDates(null);
    fetchDemoStudentsApi();
  };


  // MARK: API
  // fetch students API
  async function fetchDemoStudentsApi() {
    const q = query(
      collection(dbFirestore, TableName.demostudents),
      orderBy("created_at", "desc"),
      limit(Constant.perPage)
    );

    const querySnapshot = await getDocs(q);
    setDemoStudentsData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setLoading(false);
    setPage(0);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  }


  //  fetch course API
  async function fetchCoursesApi() {
    let q = query(collection(dbFirestore, TableName.courses));

    const querySnapshot = await getDocs(q);
    setCourseData(
      querySnapshot.docs.map((docs) => ({
        ...docs.data(),
        firebase_id: docs.id,
      }))
    );
  }

  // start loop to get data from the course list and compare id of course with the demo_category id
  const demoCategory = (studentModel) => {
    var courseObject = courseData.find(function (course) {
      return course.id === studentModel.selected_course_id;
    });

    return `${courseObject.name}`;
  }

  // delete API
  const deleteDemoStudentsApi = async (demoStudents) => {
    await deleteDoc(doc(dbFirestore, TableName.demostudents, demoStudents.id));
    setDemoStudentsData((prevState) =>
      prevState.filter((el) => el.id !== demoStudents.id)
    );
    toast.success(ToastMessages.demoStudentsDelete);
  };

  // serach api
  const searchDemoStudentsApi = async (e) => {
    const searchText = e.target.value.toLowerCase();
    setGlobalFilterValue(searchText);

    if (searchText) {
      let q = query(
        collection(dbFirestore, TableName.demostudents),
        or(
          and(
            where("name", ">=", searchText),
            where("name", "<=", searchText + "\uf8ff")
          ),
          and(
            where(
              "name",
              ">=",
              searchText.charAt(0).toUpperCase() + searchText.slice(1)
            ),
            where(
              "name",
              "<=",
              searchText.charAt(0).toUpperCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          ),
          and(
            where(
              "name",
              ">=",
              searchText.charAt(0).toLowerCase() + searchText.slice(1)
            ),
            where(
              "name",
              "<=",
              searchText.charAt(0).toLowerCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          )
        )
      );
      const querySnapshot = await getDocs(q);

      // set data from docs
      setDemoStudentsData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
    } else {
      fetchDemoStudentsApi();
    }
  };

  // MARK: pagination code
  const showNext = ({ item }) => {
    setPage(page + 1);

    const fetchNextData = async () => {
      var paginationQuery;

      paginationQuery = query(
        collection(dbFirestore, TableName.demostudents),
        orderBy("created_at", "desc"),
        limit(Constant.perPage),
        startAfter(item.created_at)
      );
      const querySnapshot = await getDocs(paginationQuery);

      setDemoStudentsData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
      setPage(page + 1);
      setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    if (demoStudentsData.length === 0) {
      alert(ToastMessages.alertMessage);
    } else {
      fetchNextData();
    }
  };

  //  previous data function using pagination previous button
  const fetchPreviousData = async () => {
    setPage(page - 1);

    var paginationQuery;
    paginationQuery = query(
      collection(dbFirestore, TableName.demostudents),
      orderBy("created_at", "desc"),
      endBefore(demoStudentsData[0].created_at),
      limitToLast(Constant.perPage)
    );
    const querySnapshot = await getDocs(paginationQuery);

    setDemoStudentsData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setPage(page - 1);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // condition while selecting the previous button
  const showPrevious = () => {
    if (demoStudentsData.length === 0) {
      fetchDemoStudentsApi();
    } else {
      fetchPreviousData();
    }
  };

  // MARK: filter dates
  function getFilteredDatesTimeStamp() {
    if (filteredDates) {
      const startDate = moment(filteredDates[0]).format(Dateformat.YYYYMMDD);
      const endDate = moment(filteredDates[1]).format(Dateformat.YYYYMMDD);

      const startTimestamp = Timestamp.fromDate(new Date(startDate)).toMillis();
      const endTimestamp = Timestamp.fromDate(new Date(endDate)).toMillis();
      return { startTime: startTimestamp, endTime: endTimestamp };
    }
    return null;
  }

  // MARK: filter function using in input
  const tapOnFilterButton = async () => {
    const querySnapshot = await createQueryForTable();

    const array = querySnapshot.docs.map((docs) => ({ ...docs.data() }));
    setDemoStudentsData(array);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  async function createQueryForTable() {
    const filterText = filteredDates;

    if (!filterText) {
      toast.error(ToastMessages.filterDate);
      <ToastContainer />
    }

    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.demostudents),
        where("created_at", ">=", getFilteredDatesTimeStamp().startTime),
        where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
        orderBy("created_at", "desc"), limit(Constant.perPage)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      const q = query(
        collection(dbFirestore, TableName.demostudents),
        orderBy("created_at", "desc"),
        limit(Constant.perPage)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  async function createQueryForExport() {
    const filterText = filteredDates;

    if (!filterText) {
      toast.error(ToastMessages.filterDate);
      <ToastContainer />
    }

    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.demostudents),
        where("created_at", ">=", getFilteredDatesTimeStamp().startTime),
        where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
        orderBy("created_at", "desc")
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      const q = query(
        collection(dbFirestore, TableName.demostudents),
        orderBy("created_at", "desc"),
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  //MARK: Search UI
  const searchBar = () => {
    return (
      <>
        <div className="search__main_div">
          <div style={{ flexGrow: "1" }}>
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                type="search"
                value={globalFilterValue}
                onChange={searchDemoStudentsApi}
                placeholder="Search by name"
              />
            </IconField>
          </div>
          <div className="filter__button-section">
            <Calendar
              value={filteredDates}
              onChange={tapOnDateInput}
              selectionMode="range"
              readOnlyInput
              showIcon
              placeholder="Select start and end date"
            />

            <Button
              type="button"
              label="Filter"
              className="list__filter_button ms-2 me-2"
              onClick={tapOnFilterButton}
            />
            <Button
              type="button"
              label="Reset"
              className="list__reset_button"
              onClick={tapOnResetButton}
            />
          </div>
        </div>
      </>
    );
  };

  const header = searchBar();

  if (isLoading) {
    return <div className="loading-div"> Loading ... </div>;
  }

  // MARK: demo students columns data
  const demoStudentsColumns = [
    {
      field: "name",
      header: "Name",
      className: "table__column__capital",
    },
    {
      field: "demo_date",
      header: "Demo Date",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYY}>{data.demo_date}</Moment>
      ),
    },
    {
      field: "selected_course_id",
      header: "Demo Course",
      CardBody: (data) => demoCategory(data),
      className: "table__column__uppercase",
    },
    {
      field: "created_at",
      header: "Created At",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYHHMMSS}>{data.created_at}</Moment>
      ),
    },
    {
      field: "actions",
      header: "Actions",
      CardBody: (data) => (
        <>
          <ListButtons
            editclick={tapOnEdit(data)}
            deleteclick={tapOnDeleteConfirm(data)}
          />
          <ToastContainer />
        </>
      ),
    },
  ];

  // MARK: modify student model in which we add new inputs in an array

  function modifyStudentModel(doc) {
    const data = doc.data();
    var courseObject = courseData.find(function (course) {
      return course.id === data.selected_course_id;
    });

    return {
      name: data.name,
      email: data.email,
      phone: data.phone,
      address: data.address,
      demo_date: moment(data.demo_date_num).format(
        Dateformat.YYYYMMDD
      ),
      selected_course_id: courseObject.name,
      created_at: moment(data.created_at).format(
        Dateformat.YYYYMMDD
      ),

    };
  }

  // MARK: export data in the excel sheet
  const exportToExcel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to export these data.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.value) {
        const querySnapShot = await createQueryForExport();

        const mylist = querySnapShot.docs.map((model) =>
          modifyStudentModel(model)
        );

        const filterUserData = mylist.map(
          ({ name, demo_date, address, course, created_at }) => ({
            name: name,
            demo_date: demo_date,
            address: address,
            course: course,
            created_at: created_at,
          })
        );
        if (filteredDates) {
          const workBook = XLSX.utils.book_new();
          const workSheet = XLSX.utils.json_to_sheet(filterUserData);
          XLSX.utils.book_append_sheet(workBook, workSheet, "students");
          XLSX.writeFile(workBook, "demo_students_data.xlsx");
        } else {
          toast.error(ToastMessages.filterDate)
        }
      }
    });
  };

  // MARK: UI start
  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <div className="modules__lists_main-content">
            <ListHeadingComponent
              classname="flex-grow-1"
              headingName={CommonHeadings.demoListLayoutHeading}
            />
            <Button
              label="Export Data"
              type="button"
              onClick={exportToExcel}
              className="list__export_button me-2"
            />
            <AddButton navigation={RoutingPaths.addDemoStudents} />
          </div>
          <DataTable
            className="mt-5 mb-3"
            value={demoStudentsData}
            header={header}
            emptyMessage="No data found."
          >
            {demoStudentsColumns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                bodyClassName={col.className}
                body={col.CardBody}
              />
            ))}
          </DataTable>

          <ButtonGroup
            style={{ gap: "1rem", alignSelf: "center" }}
            className="mt-5"
          >
            {
              <button
                disabled={page === 0 ? true : false}
                onClick={() => showPrevious()}
                className={
                  page === 0 ? "previous-disabled-button" : "previous-button"
                }
              >
                <span className="pi pi-angle-left">Previous</span>
              </button>
            }

            {
              <button
                disabled={isNext}
                onClick={() =>
                  showNext({
                    item: demoStudentsData[demoStudentsData.length - 1],
                  })
                }
                className={
                  isNext ? "previous-disabled-button" : "previous-button"
                }
              >
                Next<span className="pi pi-angle-right"></span>
              </button>
            }
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
}

export default DemoStudentsList;
